import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OtaMasterComponent } from './ota-master.component';

const routes: Routes = [
  {
    path: 'ota-master',
    data: { name: 'Ota Master', isTab: false },
    component: OtaMasterComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OtaMasterRoutingModule {}
